<template>
  <div class="modal fade" id="chooseStudentByUcoModalForm" tabindex="-1" aria-labelledby="chooseStudentByUcoModalFormLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">    
        <div class="modal-header">
          <h5 class="modal-title" id="chooseStudentByUcoModalFormLabel">{{ title }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitForm">
            <div class="mb-3">
              <label for="student_uco" class="form-label" v-if="!allowMultiple">Enter one student uco:</label>
              <label for="student_uco" class="form-label" v-else>Enter student ucos (separated by comma):</label>
              <input type="string" id="student_uco" class="form-control" v-model="studentUco" :placeholder="allowMultiple ? '123456, 987654' : '123456'" required>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="submit" class="btn btn-primary" :disabled="!studentUco">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <StemErrorModal ref="stemErrorModal" />
</template>

<script>
import { Modal } from 'bootstrap';
import StemErrorModal from '@/components/StemErrorModal.vue';

export default {
  name: 'ChooseStudentByUcoModalForm',
  components: {
    StemErrorModal
  },
  props: {
    title: {
      type: String,
      default: 'Enter Student UCO'
    },
    allowMultiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      studentUco: null,
    };
  },
  mounted() {
    // Reset = delete value from the form
    const modalElement = document.getElementById('chooseStudentByUcoModalForm');
    modalElement.addEventListener('hidden.bs.modal', this.resetForm);
  },
  methods: {
    resetForm() {
      this.studentUco = null;
    },
    submitForm() {
      // Check if studentUco is not empty
      if (!this.studentUco || (this.studentUco && this.studentUco.trim() === '')) {
        this.$refs.stemErrorModal.show('Error', 'Please enter a valid student UCO.');
        return;
      }

      // Check validation based on allowMultiple
      if (this.allowMultiple) {
        // validate list of ints/strings separated by comma
        const parts = this.studentUco.split(',');
        const invalid = parts.some(p => isNaN(p.trim()) || p.trim() === '');
        if (invalid) {
            this.$refs.stemErrorModal.show('Error', 'Please enter valid student UCOs separated by comma.');
            return;
        }
      } else {
        // validate single int
        if (isNaN(this.studentUco) || this.studentUco.includes(',')) {
            this.$refs.stemErrorModal.show('Error', 'Please enter a single valid student UCO.');
            return;
        }
      }

      // Programmatically hide the modal on success
      const modalElement = document.getElementById('chooseStudentByUcoModalForm');
      const modalInstance = Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      }

      this.$emit('submitForm', this.studentUco);
    }
  }
};
</script>